import React from 'react';
import { MediaImage } from '~/components/elements/Media';

export const LogosWithTitle = (props) => {
    
    const { title, logoGroup, backgroundImage } = props;
    
    return (
        <section className="py-2 px-4 font-sans">
            <div className="main-content-section rounded-2xl w-full max-w-[1200px] h-[194px]  mx-auto my-4 flex flex-wrap justify-center items-center gap-8 " style={{ backgroundImage: `url(${backgroundImage.localFile.publicURL})`, backgroundSize: "cover", backgroundPosition: "center" }}>
                <div className="text-center">
                    <h3 className="text-white text-lg sm:text-xl font-semibold   mb-4 pt-4">
                        <span className="text-[36px] font-p22-mackinac-pro font-semibold">{title}</span>
                    </h3>
                    <div className="flex flex-wrap items-center justify-center pt-image-logos">
                        {logoGroup?.logos?.map((logo, i) => (
                            <MediaImage key={i} image={logo.image} className="w-[250px] h-[81px] mx-auto" objectFit="contain" />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};